import styled from "styled-components";

export const StyledAppBreadcrumbsContainer = styled.div`
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  .full-screen {
    align-items: center;
    display: flex;
    cursor: pointer;
    svg {
      margin-right: 8px;
    }
  }
`;

export const StyledAppBreadcrumbsHomeIconContainer = styled.div`
  svg {
    vertical-align: text-bottom;
  }
`;
